import {Injectable} from "@angular/core";
import {ApiService} from "./api.service";
import {Group, GroupDatabasesInfo, ListOfIds, User} from "@icure/api";
import {DesktopService} from "./desktop.service";
import {FetchService} from "./fetch.service";
// @ts-ignore
import {v4 as uuidv4} from 'uuid';
import {GroupCredentials, ReplicationInfos} from "../models/group.model";

const GROUP_CREATION_ENDPOINT = 'https://api.icure.cloud/rest/v2/group/';
const CREATE_GROUP_PARAMS = '&q=8&server=cluster-02';

@Injectable({
  providedIn: 'root',
})
export class GroupService{
  constructor(
    private api: ApiService,
    private fetchService: FetchService,
    private desktopService: DesktopService
  ) {
  }

  public async getAllGroups(): Promise<Array<Group>>{
    return await this.api.groupApi?.listGroups()!!;
  }

  public async getGroup(groupId: string): Promise<Group>{
    return await this.api.groupApi?.getGroup(groupId)!!;
  }

  public async getGroupStorageInfos(groupId: string): Promise<GroupDatabasesInfo>{
    const groupDatabasesInfos = await this.api.groupApi?.getGroupsStorageInfos(new ListOfIds({ids: [groupId]}))!!;
    return groupDatabasesInfos?.[0];
  }

  public async getGroupsStorageInfos(groupIds: Array<string>): Promise<Array<GroupDatabasesInfo>>{
    return await this.api.groupApi?.getGroupsStorageInfos(new ListOfIds({ids: groupIds}))!!;
  }

  public async createGroup(groupId: string, credentials: GroupCredentials, replicationInfos: ReplicationInfos) {
    const url: string = `${GROUP_CREATION_ENDPOINT}${groupId}?name=${groupId}` + CREATE_GROUP_PARAMS;
    const resp = await this.fetchService.executeFetchRequest(`${url}`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: 'Basic ' + btoa(credentials?.login + ':' + credentials?.password),
        Accept: 'application/json',
        'Content-Type': 'application/json',
        password: uuidv4()
      },
      body: JSON.stringify(replicationInfos)
    })

    return {
      status: {
        status: resp?.response?.status,
        statusText: resp?.response?.statusText,
      },
      content: resp?.content
    };
  }
}
